import { compareWithInitVal } from '../../../../../../shared/lib/formFieldValidators';

export const getValidationRules = ({ initialValue, editMode }) =>
  editMode ? [{ validator: compareWithInitVal(initialValue ?? '') }] : [];
